//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TypographyHeadlines from './TypographyHeadlines.vue'
import TypographyTexts from './TypographyTexts.vue'

export default {
  components: {
    TypographyHeadlines,
    TypographyTexts,
  },
}
